import { render } from "./Pelunasan.vue?vue&type=template&id=66f0d9f6"
import script from "./Pelunasan.vue?vue&type=script&lang=js"
export * from "./Pelunasan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__